module.exports = __webpack_public_path__ + "img/组 828.f907ae4f.png";